import { _elements } from './_elements';
import { _fade } from './_fade';

export const _autoplay = ( slider ) => {

	if ( ! slider ) {
		return;
	}

	const {
		current,
		items,
	} = _elements( slider );

	if ( items[ current + 1 ] ) {
		_fade( slider, current + 1 );
	} else {
		_fade( slider, 0 );
	}
};
